import { USER_KEY } from '@gymaholic/packages'
import getValueReduxUtil from 'modules/redux/utils/get-value'

function getSubscriptionPlanTrainingUserUtil (user) {
  return getValueReduxUtil(user, USER_KEY.SUBSCRIPTION_PLAN)
}

export default getSubscriptionPlanTrainingUserUtil
